<template>
  <div 
    v-html="options.content" 
    class="content-field">
  </div>
</template>

<script>
export default { 
  name: 'ContentField',
  props: {
    options: {
      type: Object,
      required: true
    }
  }
}
  
</script>
